import { render, staticRenderFns } from "./PesquisaFisicaMental.vue?vue&type=template&id=195167e4&scoped=true"
import script from "./PesquisaFisicaMental.vue?vue&type=script&lang=js"
export * from "./PesquisaFisicaMental.vue?vue&type=script&lang=js"
import style0 from "./PesquisaFisicaMental.vue?vue&type=style&index=0&id=195167e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195167e4",
  null
  
)

export default component.exports